import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Global handler for Stripe hosted-page returns (?setup_session_id=...).
 * Confirms the saved card server-side (polling path — webhooks are the
 * production path), toasts, and strips the param from the URL.
 */
export const StripeReturnHandler = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const handled = useRef(new Set());

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get("setup_session_id");
    if (!sessionId || !user || handled.current.has(sessionId)) return;
    handled.current.add(sessionId);
    api
      .get(`/verification/card/status`, { params: { session_id: sessionId } })
      .then(({ data }) => {
        if (data.has_card) {
          toast.success(t("vrf.cardSaved", { last4: data.card?.last4 || "" }));
        }
      })
      .catch(() => {})
      .finally(() => {
        params.delete("setup_session_id");
        navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
      });
  }, [location, user, navigate, t]);

  return null;
};
